<!--
 * @Author: lishiqiao
 * @Date: 2022-03-09 16:59:07
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-10 10:48:39
-->
<template>
  <!-- 育苗收获概览产量 -->
  <div class="page-list">
    <!-- 汇总表 -->
    <SummaryPage v-if="pageType === 'summary'" @getPageType="getPageType" />
    <!-- 明细表 -->
    <DetailPage v-if="pageType === 'detail'" @getPageType="getPageType" />
  </div>
</template>

<script>
import SummaryPage from "./ym-harvest-output-summary.vue";
import DetailPage from "./ym-harvest-output-detail.vue";
export default {
  name: "ym-harvest",
  data() {
    return {
      pageType: "summary", // summary汇总表,detail明细表
    };
  },
  computed: {},
  methods: {
    getPageType(pageType) {
      this.pageType = pageType;
    },
  },
  components: {
    SummaryPage,
    DetailPage,
  },
};
</script>

<style lang="less" scoped>
</style>